import type { FaireProductEntity } from "../../entity_types/product";

export const p_g7zntty5j3: FaireProductEntity = {
  token: "p_g7zntty5j3",
  type: "product",
  name: "The Homebody Club Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/6f297aabef6843d17226dc3311cbcd61ce710d8bad416669e479fb10b286d4df.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/041077a0bf0318587a41ea97576096f460f0c333c07e6af5fd57a7bcff2bc745.jpeg",
    "https://cdn.faire.com/fastly/b67b8b6fec9bf0fee67f4ceec5895acfe7a46debea3656c54efbf2d668da427e.jpeg",
    "https://cdn.faire.com/fastly/ccbbcdfcf8501ba1a3dbe85a0acf6568f7f5df0f2055c4fe1741908e39b5136e.jpeg"
  ],
  priceDollars: 5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying hand illustrated stars and \"The Homebody Club\" sentiment perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our The Homebody Club metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:38.233Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
